// import React, { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import { FaStar, FaShoppingCart, FaEye, FaHeart } from "react-icons/fa";
// import axios from "axios";
// import { formatPrice, getCurrencySymbol } from "../../utils/currency";
// import { useTranslation } from "react-i18next";

// const API_BASE = "https://api.mahal.qa";
// const ITEMS_PER_PAGE = 12;

// const NewProducts = () => {
//   const [products, setProducts] = useState([]);
//   const [startIndex, setStartIndex] = useState(0);
//   const [ratings, setRatings] = useState({}); // ✅ NEW
//   const { t, i18n } = useTranslation();
// const isArabic = i18n.language === "ar";

// const getProductName = (item) => {
//   return isArabic
//     ? item.title_ar || item.product_name_arabic || item.title
//     : item.title_en || item.product_name_english || item.title;
// };

// const localizeNumber = (value) => {
//   return new Intl.NumberFormat(isArabic ? "ar-QA" : "en-US").format(
//     Number(value || 0)
//   );
// };

// const localizeDecimal = (value) => {
//   return new Intl.NumberFormat(isArabic ? "ar-QA" : "en-US", {
//     minimumFractionDigits: 1,
//     maximumFractionDigits: 1,
//   }).format(Number(value || 0));
// };

// const localizeCurrency = (value) => {
//   return isArabic
//     ? `${localizeNumber(value)} ${t("qar")}`
//     : `${t("qar")} ${localizeNumber(value)}`;
// };

//   /* ================= FETCH ================= */
//   useEffect(() => {
//     fetch(`${API_BASE}/api/trending`)
//       .then((res) => res.json())
//       .then((data) => {
//         const items = data.products || [];

//         const mapped = items.map((item) => ({
//           id: item.id,
//           title: item.name_en || item.product_name_english || item.name,
//           title_en: item.name_en || item.product_name_english || item.name,
//           title_ar: item.name_ar || item.product_name_arabic || item.name,
//           price: item.price_numeric || 0,
//           currency: item .currency || "QAR",
//           rating: item.rating || 4,
//           img:
//             item.img1 && item.img1.trim() !== ""
//               ? item.img1.startsWith("http")
//                 ? item.img1
//                 : `${API_BASE}/${item.img1}`
//               : null,
//         }));

//         setProducts(mapped);
//         fetchRatings(mapped);
//       })
//       .catch((err) => {
//         console.error("❌ Trending API error:", err);
//       });
//   }, []);

//   /* ================= FETCH RATINGS ================= */
//   const fetchRatings = async (products) => {
//     try {
//       const ratingData = {};

//       await Promise.all(
//         products.map(async (p) => {
//           try {
//             const res = await fetch(
//               `${API_BASE}/api/reviews/product/${p.id}`
//             );
//             const data = await res.json();

//             if (data.length > 0) {
//               const total = data.reduce((sum, r) => sum + r.rating, 0);
//               ratingData[p.id] = total / data.length;
//             } else {
//               ratingData[p.id] = 0;
//             }
//           } catch {
//             ratingData[p.id] = 0;
//           }
//         })
//       );

//       setRatings(ratingData);
//     } catch (err) {
//       console.error("Rating fetch error:", err);
//     }
//   };

//   /* ================= AUTO CHANGE ================= */
//   useEffect(() => {
//     if (products.length <= ITEMS_PER_PAGE) return;

//     const interval = setInterval(() => {
//       setStartIndex((prev) => {
//         const next = prev + ITEMS_PER_PAGE;
//         return next >= products.length ? 0 : next;
//       });
//     }, 10800000);

//     return () => clearInterval(interval);
//   }, [products]);

//   /* ================= ADD TO CART ================= */
// const addToCart = (item) => {

//   const token = localStorage.getItem("token");

//   if (!token) {
//     alert(t("please_login"));
//     return;
//   }

//   axios.post(
//     `${API_BASE}/api/cart/add`,
//     {
//       product_id: item.id,
//       quantity: 1,
//       price: item.price,
//     },
//     {
//       headers: {
//         Authorization: `Bearer ${token}`,
//       },
//     }
//   )

//   .then((res) => {

//     // ✅ Product already exists
//     if (res.data.status === "exists") {
//       alert(t("product_already_cart"));

//     }

//     // ✅ New product added
//     else {

//       alert(t("added_to_cart"));

//     }

//   })

//   .catch((err) => {

//     console.error(
//       "ADD TO CART ERROR",
//       err
//     );

//       alert(err.response?.data?.error || t("backend_error"));

//   });

// };
//   /* ================= ADD TO WISHLIST ================= */
//   const addToWishlist = (item) => {
//     const token = localStorage.getItem("token");

//     if (!token) {
//       alert(t("please_login"));
//       return;
//     }

//     axios.post(
//       `${API_BASE}/api/wishlist/add`,
//       {
//         product_id: item.id,
//       },
//       {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       }
//     )
//     .then(() => {
//       alert(t("added_to_wishlist"));
//     })
//     .catch((err) => {
//       if (err.response?.status === 409) {
//         alert(t("already_in_wishlist"));
//       } else {
//         console.error("WISHLIST ERROR", err);
//         alert(t("wishlist_backend_error"));
//       }
//     });
//   };

//   /* ================= VISIBLE PRODUCTS ================= */
//   const visibleProducts = products.slice(
//     startIndex,
//     startIndex + ITEMS_PER_PAGE
//   );

//   return (
//     <>
//       <style>
//         {`
//           .mm-trending-img {
//             width: 100%;
//             height: 220px;   /* same fixed height */
//             overflow: hidden;

//             display: flex;
//             align-items: center;
//             justify-content: center;

//             background: #fff;
//           }

//           .mm-trending-img img {
//             width: 100%;
//             height: 100%;

//             object-fit: contain;   /* full image visible */
//             /* object-fit: cover; */ /* use this if you want crop-fill */

//             transition: 0.3s;
//           }

//           .mm-trending-card {
//             height: 100%;
//           }

//           .mm-trending-info h4 {
//             min-height: 48px;
//           }
//         `}
//       </style>
//       <section className="trending_products bg1" dir={isArabic ? "rtl" : "ltr"}>
//         <div className="container">

//           <div className="row">
//             <div className="col-xl-6 m-auto text-center">
//               <div className="section_heading mb-3">
//                 <h4 className="premium_badge text-white">
//                   {t("trending_now")}
//                 </h4>
//                 <h2 className="premium_title">
//                   {t("discover_loving_today")}
//                 </h2>
//               </div>
//             </div>
//           </div>

//           <div className="row mt-4">
//             {visibleProducts.length === 0 ? (
//               <p className="text-center">{t("loading_products")}</p>
//             ) : (
//               visibleProducts.map((item) => {
//                 const ratingValue = ratings[item.id] || 0; // ✅ NEW

//                 return (
//                   <div
//                     key={item.id}
//                     className="col-xl-2 col-lg-3 col-sm-6 mb-4"
//                   >

//                     <div className="mm-trending-card">

//                       <span className="mm-trend-tag new">{t("new")}</span>

//                       <div className="mm-trending-img">
//                       <img
//                         src={
//                           item.img && item.img.trim() !== ""
//                             ? item.img.startsWith("http")
//                               ? item.img
//                               : `${API_BASE}/${item.img}`
//                             : null
//                         }
//                         alt={getProductName(item)}
//                         onError={(e) => {
//                           console.log("Image failed:", item.img);
//                           e.target.style.display = "none";
//                         }}
//                       />
//                       </div>

//                       <div className="mm-trend-actions">

//                         <button onClick={() => addToCart(item)}>
//                           <FaShoppingCart />
//                         </button>

//                         <Link to={`/shopdetails/${item.id}`}>
//                           <FaEye />
//                         </Link>

//                         <button onClick={() => addToWishlist(item)}>
//                           <FaHeart />
//                         </button>

//                       </div>

//                       <div className="mm-trending-info">
//                         <h4>{getProductName(item)}</h4>

//                         {/* ✅ UPDATED RATING */}
//                         <div className="mm-trend-rating">
//                           {Array.from({ length: 5 }).map((_, i) => (
//                             <FaStar
//                               key={i}
//                               color={
//                                 i < Math.round(ratingValue)
//                                   ? "#f59e0b"
//                                   : "#e5e7eb"
//                               }
//                             />
//                           ))}

//                           <span className="ms-1 text-muted">
//                             ({localizeDecimal(ratingValue)})
//                           </span>
//                         </div>

//                         <div className="mm-price">
//                           {localizeCurrency(item.price)}
//                         </div>

//                         <Link
//                           to={`/shopdetails/${item.id}`}
//                           className="add_cart_btn"
//                         >
//                           {t("view_product")}
//                         </Link>

//                       </div>

//                     </div>

//                   </div>
//                 );
//               })
//             )}
//           </div>

//         </div>
//       </section>
//     </>
//   );
// };

// export default NewProducts;



import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FaStar, FaShoppingCart, FaEye, FaHeart } from "react-icons/fa";
import axios from "axios";
import { formatPrice, getCurrencySymbol } from "../../utils/currency";

const API_BASE = "https://api.mahal.qa";
const ITEMS_PER_PAGE = 12;

const NewProducts = () => {
  const [products, setProducts] = useState([]);
  const [startIndex, setStartIndex] = useState(0);

  /* ================= FETCH ================= */
  useEffect(() => {
    fetch(`${API_BASE}/api/trending`)
      .then((res) => res.json())
      .then((data) => {
        const items = data.products || [];

        const mapped = items.map((item) => ({
          id: item.id,
          title: item.name,
          // price: item.price_numeric || 0,
          price: parseFloat(item.price_numeric ?? 0),
          currency: item.currency?.trim() || "QAR",
          currency_symbol: item.currency_symbol || "ر.ق",
          unit_of_measure: item.unit_of_measure || "",
          // rating: item.rating || 4,
          rating: item.rating ?? 0,
          img:
            item.img1 && item.img1.trim() !== ""
              ? item.img1.startsWith("http")
                ? item.img1
                : `${API_BASE}/${item.img1}`
              : null,

          has_offer: item.has_offer,
          offer_type: item.offer_type,
          offer_label: item.offer_label,

          discounted_price: item.discounted_price,
          original_price: item.original_price,

          price: parseFloat(item.price_numeric ?? 0),
        }));
        

        setProducts(mapped);
      })
      .catch((err) => {
        console.error("❌ Trending API error:", err);
      });
  }, []);

  /* ================= AUTO CHANGE ================= */
  // useEffect(() => {
  //   if (products.length <= ITEMS_PER_PAGE) return;

  //   const interval = setInterval(() => {
  //     setStartIndex((prev) => {
  //       const next = prev + ITEMS_PER_PAGE;
  //       return next >= products.length ? 0 : next;
  //     });
  //   }, 10800000);

  //   return () => clearInterval(interval);
  // }, [products]);

  /* ================= ADD TO CART ================= */
  const addToCart = (item) => {
    const token = localStorage.getItem("token");

    if (!token) {
      alert("Please login");
      return;
    }

    axios.post(
      `${API_BASE}/api/cart/add`,
      {
        product_id: item.id,
        quantity: 1,
        price: item.price,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
    .then(() => {
      alert("Added to cart 🛒");
    })
    .catch((err) => {
      console.error("ADD TO CART ERROR", err);
      alert("Backend error");
    });
  };

  /* ================= ADD TO WISHLIST ================= */
  const addToWishlist = (item) => {
    const token = localStorage.getItem("token");

    if (!token) {
      alert("Please login");
      return;
    }

    axios.post(
      `${API_BASE}/api/wishlist/add`,
      {
        product_id: item.id,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
    .then(() => {
      alert("Added to wishlist ❤️");
    })
    .catch((err) => {
      if (err.response?.status === 409) {
        alert("Already in wishlist");
      } else {
        console.error("WISHLIST ERROR", err);
        alert("Wishlist backend error");
      }
    });
  };

  /* ================= VISIBLE PRODUCTS ================= */
  const visibleProducts = products.slice(
    startIndex,
    startIndex + ITEMS_PER_PAGE
  );

  // const visibleProducts = products;

  return (
    <>
      <style>
        {`
          .mm-trending-img {
            width: 100%;
            height: 220px;   /* same fixed height */
            overflow: hidden;

            display: flex;
            align-items: center;
            justify-content: center;

            background: #fff;
          }

          .mm-trending-img img {
            width: 100%;
            height: 100%;

            object-fit: contain;   /* full image visible */
            /* object-fit: cover; */ /* use this if you want crop-fill */

            transition: 0.3s;
          }

          .mm-trending-card {
            height: 100%;
          }

          .mm-trending-info h4{
            font-size:16px;
            line-height:22px;

            min-height:28px;

            margin:0;

            display:-webkit-box;
            -webkit-line-clamp:2;
            -webkit-box-orient:vertical;

            overflow:hidden;
          }

          .mm-trending-info{
            display:flex;
            flex-direction:column;
            align-items:center;

            padding:10px 8px 14px;

            gap:8px;

            height:auto;
          }

          .mm-price{
            margin-top:0 !important;
            margin-bottom:6px;

            display:flex;
            align-items:center;
            justify-content:center;

            font-size:18px;
            font-weight:700;
          }

          .mm-trending-card{
            height:100%;
            position:relative;
            display:flex;
            flex-direction:column;
          }

          .mm-unit-tag{
            position:absolute;
            top:10px;
            right:10px;

            background:#f3f4f6;
            color:#555;

            font-size:11px;
            font-weight:700;

            padding:4px 8px;

            border-radius:6px;

            z-index:10;
          }

          .mm-price{
            display:flex;
            align-items:center;
            justify-content:center;

            gap:4px;
          }

          .mm-price{
            background: transparent !important;
            padding: 0 !important;
            border: none !important;
            box-shadow: none !important;
          }

          .mm-new-price{
            background: transparent !important;
            color:#111 !important;

            padding:0 !important;
            border-radius:0 !important;

            font-size:18px;
            font-weight:700;
          }

          .mm-currency{
            background:transparent !important;

            font-size:15px;
            font-weight:600;

            color:#444;
          }
        `}
      </style>
      <section className="trending_products bg1">
        <div className="container">

          <div className="row">
            <div className="col-xl-6 m-auto text-center">
              <div className="section_heading mb-3">
                <h4 className="premium_badge text-white">
                  Trending Now
                </h4>
                <h2 className="premium_title">
                  Discover what people are loving today
                </h2>
              </div>
            </div>
          </div>

          <div className="row mt-4">
            {visibleProducts.length === 0 ? (
              <p className="text-center">Loading products...</p>
            ) : (
              visibleProducts.map((item) => {
                // const ratingValue = ratings[item.id] || 0; // ✅ NEW

                const ratingValue = item.rating ?? 0;

                return (
                  <div
                    key={item.id}
                    // className="col-xl-2 col-lg-3 col-sm-6 mb-4"
                    className="col-xl-2 col-lg-3 col-md-4 col-sm-6 mb-4"
                  >

                    <div className="mm-trending-card">

                      <span className="mm-trend-tag new">New</span>

                      <div className="mm-trending-img">
                      <img
                        loading="lazy"
                        fetchpriority="high"
                        decoding="async"
                        src={
                          item.img && item.img.trim() !== ""
                            ? item.img.startsWith("http")
                              ? item.img
                              : `${API_BASE}/${item.img}`
                            : null
                        }
                        alt={item.title}
                        onError={(e) => {
                          console.log("Image failed:", item.img);
                          e.target.style.display = "none";
                        }}
                      />

                      <span className="mm-unit-tag">
                        {item.unit_of_measure
                          ? item.unit_of_measure.toUpperCase()
                          : "UNIT"}
                      </span>

                      </div>

                      <div className="mm-trend-actions">

                        <button onClick={() => addToCart(item)}>
                          <FaShoppingCart />
                        </button>

                        <Link to={`/shopdetails/${item.id}`}
                          state={{
                            offerData: {
                              has_offer: item.has_offer,
                              offer_type: item.offer_type,
                              offer_label: item.offer_label,
                              discounted_price: item.discounted_price,
                              original_price: item.original_price,
                            }
                          }}
                        >
                          <FaEye />
                        </Link>

                        <button onClick={() => addToWishlist(item)}>
                          <FaHeart />
                        </button>

                      </div>

                      <div className="mm-trending-info">
                        <h4>{item.title}</h4>

                        {/* ✅ UPDATED RATING */}
                        <div className="mm-trend-rating">
                          {Array.from({ length: 5 }).map((_, i) => (
                            <FaStar
                              key={i}
                              color={
                                i < Math.round(ratingValue)
                                  ? "#f59e0b"
                                  : "#e5e7eb"
                              }
                            />
                          ))}

                          <span className="ms-1 text-muted">
                            ({ratingValue.toFixed(1)})
                          </span>
                        </div>

                        <div className="mm-price">

                          {/* QAR{item.price.toFixed(2)} */}
                          {/* {formatPrice(item.price, item.currency)} */}

                          {item.currency === "INR" ? (
                            <>
                              <span className="mm-new-price">
                                ₹ {parseFloat(item.price || 0).toFixed(2)}
                              </span>
                            </>
                          ) : (
                            <>
                              <span className="mm-new-price">
                                {parseFloat(item.price || 0).toFixed(2)}
                              </span>

                              <span className="mm-currency">
                                {getCurrencySymbol(item.currency)}
                              </span>
                            </>
                          )}

                        </div>

                        <Link
                          to={`/shopdetails/${item.id}`}
                          state={{
                            offerData: {
                              has_offer: item.has_offer,
                              offer_type: item.offer_type,
                              offer_label: item.offer_label,
                              discounted_price: item.discounted_price,
                              original_price: item.original_price,
                            }
                          }}
                          className="add_cart_btn"
                        >
                          View Product
                        </Link>

                      </div>

                    </div>

                  </div>
                );
              })
            )}
          </div>

        </div>
      </section>
    </>
  );
};

export default NewProducts;